export default __webpack_public_path__ + "static/media/temp-3.ca02d602.svg";